import { useParams, Link } from 'react-router-dom'
import './LibraryItem.css'

const LibraryItem = () => {
  const { id } = useParams()

  const libraryItems: Record<string, any> = {
    'sonic-pi': {
      title: 'CODE: Sonic Pi Sessions',
      description:
        'Curated live coding patches for rhythm, texture, and generative systems. Built to perform, remix, and extend.',
      content: [
        {
          type: 'text',
          heading: 'About',
          text: 'A tight collection of Sonic Pi sessions ranging from ambient drift to structured rhythmic engines. Each patch is annotated with clear parameters and intentional modulation points.',
        },
        {
          type: 'text',
          heading: 'Getting Started',
          text: 'Open a patch, run it once untouched, then change one parameter at a time. Treat each file like an instrument, not a finished song. Save your variations as new sessions.',
        },
      ],
    },
  
    strudel: {
      title: 'CODE: Strudel Notebooks',
      description:
        'Interactive browser notebooks for algorithmic rhythm and pattern design. Fast idea capture, clean performance workflows.',
      content: [
        {
          type: 'text',
          heading: 'About',
          text: 'A focused set of Strudel notebooks covering core pattern techniques, controlled randomness, and groove building. Each notebook is designed to be edited live and iterated quickly.',
        },
        {
          type: 'text',
          heading: 'Getting Started',
          text: 'Fork a notebook, start with one pattern, then mutate slowly. When something hits, export or record the loop and label it by BPM and mood so it stays usable later.',
        },
      ],
    },
  
    playtronica: {
      title: 'INTERFACES: Playtronica Mappings',
      description:
        'Sensor to sound mappings for touch and motion performance. Expressive control, minimal setup, high signal.',
      content: [
        {
          type: 'text',
          heading: 'About',
          text: 'Mappings that translate physical interaction into musical control. Includes setups for Touch Me, Playtron, and custom sensor pipelines with performance ready calibration notes.',
        },
        {
          type: 'text',
          heading: 'Getting Started',
          text: 'Pick one mapping and calibrate sensitivity first. Map one gesture to one sonic outcome before stacking complexity. Once it feels reliable, record a short improvisation and refine.',
        },
      ],
    },
  
    patches: {
      title: 'BLUEPRINTS: Patch Diagrams',
      description:
        'Visual system guides for generative architecture. Signal flow, routing schematics, and reusable design patterns.',
      content: [
        {
          type: 'text',
          heading: 'About',
          text: 'Blueprint level diagrams of rhythm engines, texture stacks, FX routing, and timing frameworks. Tool agnostic by design so you can rebuild them anywhere.',
        },
        {
          type: 'text',
          heading: 'Getting Started',
          text: 'Recreate one diagram in your tool of choice, then swap one module at a time. The goal is to learn the structure, not copy the exact sound.',
        },
      ],
    },
  
    stems: {
      title: 'ASSETS: Stem Library',
      description:
        'High quality stems from sessions for remixing and resampling. Clean exports, organized for reuse.',
      content: [
        {
          type: 'text',
          heading: 'About',
          text: 'Isolated stems from recorded sessions, grouped by date and mood. Designed for remixing, analysis, resampling, and building new arrangements fast.',
        },
        {
          type: 'text',
          heading: 'Getting Started',
          text: 'Start with drums plus bass, then layer one texture. If you add more than three layers early, you are probably muddying the idea. Keep it minimal and intentional.',
        },
      ],
    },
  
    'starter-kit': {
      title: 'CODE: Starter Patch Kit',
      description:
        'Minimal building blocks that each do one thing well. Combine them to build larger systems fast.',
      content: [
        {
          type: 'text',
          heading: 'About',
          text: 'Small remixable patches focused on single concepts like clocking, pattern generation, bass engines, texture loops, and macro controls. Designed to be legible and reusable.',
        },
        {
          type: 'text',
          heading: 'Getting Started',
          text: 'Choose one block, understand it fully, then chain it with another. Save combinations as named templates so your library grows into a system, not a junk drawer.',
        },
      ],
    },
  }
  

  const item = libraryItems[id || '']

  if (!item) {
    return (
      <main className="main-content">
        <div className="library-item-not-found">
          <h1>Item not found</h1>
          <Link to="/library">Back to Library</Link>
        </div>
      </main>
    )
  }

  return (
    <main className="main-content">
      <div className="library-item-page">
        <Link to="/library" className="library-item-back">
          ← back to library
        </Link>

        <div className="library-item-header">
          <h1 className="library-item-page-title">{item.title}</h1>
          <p className="library-item-page-description">{item.description}</p>
        </div>

        <div className="library-item-body">
          {item.content.map((section: any, index: number) => (
            <div key={index} className="library-item-section">
              <h2 className="library-item-section-heading">{section.heading}</h2>
              <p className="library-item-section-text">{section.text}</p>
            </div>
          ))}
        </div>
      </div>
    </main>
  )
}

export default LibraryItem
